interface Props {
  paletteOpen: boolean;
  propsOpen: boolean;
  testOpen: boolean;
  onTogglePalette: () => void;
  onToggleProps: () => void;
  onToggleTest: () => void;
  onTutorial: () => void;
  hasSelection: boolean;
}

export function MobileBottomNav({
  paletteOpen,
  propsOpen,
  testOpen,
  onTogglePalette,
  onToggleProps,
  onToggleTest,
  onTutorial,
  hasSelection,
}: Props) {
  return (
    <nav className="mobile-bottom-nav">
      <button
        className={`mbn-btn ${paletteOpen ? 'on' : ''}`}
        onClick={onTogglePalette}
        aria-label="Toggle palette"
      >
        <span className="mbn-ic">▦</span>
        <span>Palette</span>
      </button>
      <button
        className={`mbn-btn ${propsOpen ? 'on' : ''} ${!hasSelection ? 'disabled' : ''}`}
        onClick={onToggleProps}
        aria-label="Toggle properties"
        disabled={!hasSelection}
      >
        <span className="mbn-ic">◆</span>
        <span>Edit</span>
      </button>
      <button
        className={`mbn-btn ${testOpen ? 'on' : ''}`}
        onClick={onToggleTest}
        aria-label="Toggle test run"
      >
        <span className="mbn-ic">▶</span>
        <span>Test</span>
      </button>
      <button className="mbn-btn" onClick={onTutorial} aria-label="Tutorial">
        <span className="mbn-ic">?</span>
        <span>Help</span>
      </button>
    </nav>
  );
}
